const statusConfig = {
  ongoing: { bg: "#e8f0fe", color: "#1a73e8", label: "Ongoing" },
  waiting: { bg: "#fff8e1", color: "#f57c00", label: "Waiting" },
  done:    { bg: "#e8f5e9", color: "#2e7d32", label: "Done" },
  notDone: { bg: "#ffebee", color: "#c62828", label: "Not Done" },
};

const StatusTag = ({ start, end, done }) => {
  const startDate = new Date(start).getTime();
  const endDate = new Date(end).getTime();
  const today = new Date().getTime();

  let cfg = statusConfig.ongoing;
  if (startDate > today) cfg = statusConfig.waiting;
  if (done) cfg = statusConfig.done;
  if ((typeof done === "undefined" || done === false) && endDate < today) cfg = statusConfig.notDone;

  return (
    <span style={{
      display: "inline-block",
      padding: "3px 10px",
      borderRadius: "20px",
      fontSize: "0.75rem",
      fontWeight: 600,
      background: cfg.bg,
      color: cfg.color,
      letterSpacing: "0.02em",
    }}>
      {cfg.label}
    </span>
  );
};

export { statusConfig };
export default StatusTag;
